<template>
  <div class="legend">
    <div v-for="(item, index) in items" :key="index" class="legend-item">
      <span
        v-if="type === types.dot || !type"
        class="legend-item-dot"
        :style="{ 'background-color': item.color}"
      ></span>
      <span
        v-if="type === types.line"
        class="legend-item-line"
        :style="{ 'background-color': item.color }"
      ></span>
      <span class="legend-item-title">{{ item.title }}</span>
    </div>
  </div>
</template>

<script>
const types = {
  dot: "dot",
  line: "line"
};

export default {
  name: "Legend",
  data() {
    return {
      types
    };
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    type: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/utilities/initial-variables.scss";
@import "~scss/utilities/derived-variables.scss";
@import "~scss/utilities/mixins.scss";

.legend {
  display: flex;
  padding: 0.25rem 0.5rem;
  background-color: #eff4f9;
  border-radius: 3px;
  transition: $transition;

  &:hover {
    opacity: 0.24;
  }
}

.legend-item {
  display: flex;
  align-items: center;
  line-height: 1.33;
  color: rgba($black, 0.72);
  white-space: nowrap;

  &:not(:last-child) {
    margin-right: 0.75rem;
  }
}

.legend-item-title {
  font-size: 0.75rem;
}

.legend-item-dot {
  display: flex;
  width: 0.375rem;
  height: 0.375rem;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  border: 1px solid $white;
  margin-right: 0.5rem;
}

.legend-item-line {
  display: flex;
  width: 1rem;
  height: 0.125rem;
  border-radius: 2px;
  margin-right: 0.5rem;
}
</style>
